import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import announcer from './aria-announcer';

const getAdjacentSlidesLabels = (el) => {
    const prevSlide = el.querySelector('.swiper-slide-prev');
    const nextSlide = el.querySelector('.swiper-slide-next');
    const prevLabel = prevSlide?.getAttribute('aria-label');
    const nextLabel = nextSlide?.getAttribute('aria-label');
    return { prevLabel, nextLabel };
};

document.addEventListener('DOMContentLoaded', () => {
    // Case study block swipers
    const caseStudyBlocks = document.querySelectorAll('.case-study-block-swiper');

    caseStudyBlocks.forEach((el) => {
        const btnPrev = el.querySelector('.swiper-nav-prev');
        const btnNext = el.querySelector('.swiper-nav-next');

        new Swiper(el, { // eslint-disable-line no-new
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            navigation: {
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            a11y: {
                enabled: true,
                containerRole: 'group',
                containerRoleDescriptionMessage: 'carousel',
                containerMessage: 'Case study slides',
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
            },
        });

        if (btnNext && btnPrev) {
            btnNext.addEventListener('click', () => {
                const { nextLabel } = getAdjacentSlidesLabels(el);
                announcer.announce(`Next slide ${nextLabel}`);
            });

            btnPrev.addEventListener('click', () => {
                const { prevLabel } = getAdjacentSlidesLabels(el);
                announcer.announce(`Previous slide ${prevLabel}`);
            });
        }
    });

    // Filter pills
    const pills = document.querySelectorAll('.case-studies-filter-pill');
    const blocks = document.querySelectorAll('.case-study-block');
    const counterDesktop = document.querySelector('.case-studies-filters-counter');
    const counterMobile = document.querySelector('.case-studies-filters-toggle span');

    function updateCounter(count) {
        const text = `${count} case ${count === 1 ? 'study' : 'studies'} shown`;
        if (counterDesktop) counterDesktop.textContent = text;
        if (counterMobile) counterMobile.textContent = text;
    }

    function filterByTag(tag) {
        let visible = 0;
        blocks.forEach((block) => {
            const tags = block.getAttribute('data-tags').split(',');
            const show = tag === 'All' || tags.includes(tag);
            block.setAttribute('data-filtered', show ? 'true' : 'false');
            if (show) visible += 1;
        });
        updateCounter(visible);
    }

    pills.forEach((pill) => {
        pill.addEventListener('click', () => {
            pills.forEach((p) => p.classList.remove('active'));
            pill.classList.add('active');
            filterByTag(pill.textContent.trim());
        });
    });

    // Anchor navigation from homepage
    if (window.location.hash) {
        const targetId = window.location.hash.substring(1);
        const targetBlock = document.getElementById(targetId);
        if (targetBlock) {
            // Find matching tag from the block and activate the filter
            const blockTags = targetBlock.getAttribute('data-tags');
            if (blockTags) {
                const firstTag = blockTags.split(',')[0];
                pills.forEach((pill) => {
                    if (pill.textContent.trim() === firstTag) {
                        pill.click();
                    }
                });
            }
            // Scroll to block after short delay for layout
            setTimeout(() => {
                targetBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 300);
        }
    }
});
